import { render, staticRenderFns } from "./AdoptionInfo.vue?vue&type=template&id=8502befe&scoped=true"
import script from "./AdoptionInfo.vue?vue&type=script&lang=js"
export * from "./AdoptionInfo.vue?vue&type=script&lang=js"
import style0 from "./AdoptionInfo.vue?vue&type=style&index=0&id=8502befe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._pvxtve42dn25yfzifbo3bypexu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8502befe",
  null
  
)

export default component.exports